import { render, staticRenderFns } from "./dialogRewardConfirm.vue?vue&type=template&id=1ad44920"
import script from "./dialogRewardConfirm.vue?vue&type=script&lang=js"
export * from "./dialogRewardConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports